import { axiosIns } from "../utils";
import { normalizeAuthUser, persistAuthUser } from "../utils/backendApi";

export const login = async (email, password) => {
  try {
    const response = await axiosIns.post("/auth/jwt/create/", {
      email,
      password,
    });
    const authUser = normalizeAuthUser(response?.data);
    if (!authUser) return null;
    persistAuthUser(authUser);
    return authUser;
  } catch (error) {
    console.error(error);
    throw error;
  }
};
